import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import { ToastController, MenuController, NavController, PopoverController, IonContent } from '@ionic/angular';

import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { ProductoService } from 'src/app/services/producto/producto.service';

import { IProductoWeb } from 'src/app/interfaces/IProductoWeb';

import { ExistenciasPopoverComponent } from 'src/app/components/existenciasPopover/existencias-popover.component';
import { CarritoTamanoPopoverComponent } from 'src/app/components/carritoTamanoPopover/carrito-tamano-popover.component';

@Component({
  selector: 'app-categoria-detalle',
  templateUrl: './categoria-detalle.page.html',
  styleUrls: ['./categoria-detalle.page.scss'],
})
export class CategoriaDetallePage implements OnInit {

  @ViewChild(IonContent) public ionContent: IonContent;

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _categoriaWebTxt: string = null;
  public _busquedaTxt: string = null;
  public _favoritos: boolean = null;

  public _allProductosPremium: Array<IProductoWeb> = [];
  public _allProductosTrad: Array<IProductoWeb> = [];
  public _allProductosCaseros: Array<IProductoWeb> = [];
  public _allProductosPostres: Array<IProductoWeb> = [];
  public _allProductosReposteria: Array<IProductoWeb> = [];
  public _allProductosQuequitos: Array<IProductoWeb> = [];
  public _allProductosRebanadas: Array<IProductoWeb> = [];
  public _allProductosTemporada: Array<IProductoWeb> = [];

  public _showMessage: boolean;
  public _msg: string;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _navCtrl: NavController,
              private _menuCtrl: MenuController,
              private _toastCtrl: ToastController,
              private _popoverCtrl: PopoverController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _productoSrv: ProductoService) {

    console.log('CategoriaDetallePage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('CategoriaDetallePage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {

    console.log('CategoriaDetallePage >> ionViewDidEnter');

    if (this._usuarioSrv.scrollTop !== null && this._usuarioSrv.scrollTop > 0) {
      this.ionContent.scrollToPoint(0, this._usuarioSrv.scrollTop, 0);
    }

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera la categoria desde el query string, si existe
    await this._route.queryParams.subscribe((params) => {
      console.info('params[\'q\'] >> ' + params['q']);
      console.info('params[\'s\'] >> ' + params['s']);
      console.info('params[\'f\'] >> ' + params['f']);

      if (params['q'] !== undefined) {

        // asigna variable
        this._categoriaWebTxt = params['q'];
        this._busquedaTxt = null;
        this._favoritos = false;

        console.log('CategoriaDetallePage >> ionViewDidEnter >> _categoriaWebTxt >> ' + this._categoriaWebTxt);

      } else if (params['f'] !== undefined) {

        // asigna variable
        this._favoritos = true;
        this._categoriaWebTxt = null;
        this._busquedaTxt = null;

        console.log('CategoriaDetallePage >> ionViewDidEnter >> _favoritos >> ' + this._favoritos);

      } else if (params['s'] !== undefined) {

        // asigna variable
        this._busquedaTxt = params['s'];
        this._categoriaWebTxt = null;
        this._favoritos = false;

        console.log('CategoriaDetallePage >> ionViewDidEnter >> _busquedaTxt >> ' + this._busquedaTxt);

      } else { // no trae query params...redirige pagina principal de categorias
        this._navCtrl.navigateForward('/categoria');
      }
    });

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // Recupera productos, si la categoria esta seleccionada
    // limpia, para llenar
    this._allProductosPremium = [];
    this._allProductosTrad = [];
    this._allProductosCaseros = [];
    this._allProductosPostres = [];
    this._allProductosReposteria = [];
    this._allProductosQuequitos = [];
    this._allProductosRebanadas = [];
    this._allProductosTemporada = [];

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar(((this._favoritos) ? 'Favoritos' : 'CategoriaDetalle'), null, null,
        this._categoriaWebTxt, null, null, null,
        this._busquedaTxt, null,
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

    // Peticion a WebAPI
    this._productoSrv.getAllProductosWeb(this._categoriaWebTxt, this._busquedaTxt, this._favoritos).subscribe(() => {

      if (this._productoSrv.AllProductos.length == 0 && this._favoritos) {
        this._showMessage = true;
        this._msg = 'No tiene productos guardados como favoritos.';
      } else if (this._productoSrv.AllProductos.length == 0 && this._busquedaTxt !== null) {
        this._showMessage = true;
        this._msg = 'No se encontraron productos.';
      } else {

        this._showMessage = false;
        this._msg = '';

        this._productoSrv.AllProductos.forEach(item => {
          item.UrlImagen = WebAPIConstants.URLProductoImagenes + item.UrlImagen;
        });

        this._allProductosPremium = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_PREMIUM);
        this._allProductosTrad = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_TRADICIONAL);
        this._allProductosCaseros = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_CASERO);
        this._allProductosPostres = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_POSTRE);
        this._allProductosReposteria = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_REPOSTERIA);
        this._allProductosQuequitos = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_QUEQUITOS);
        this._allProductosRebanadas = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_REBANADAS);
        this._allProductosTemporada = this._productoSrv.AllProductos.filter(p => p.IdTipoSegmento == GlobalConstants.SEGMENTO_TEMPORADA);
      }
    });
  }

  //#endregion Eventos NG

  //#region Eventos Botones

  public scroll(event: any) {
    this._usuarioSrv.scrollTop = event.detail.scrollTop;
  }

  public openCategoria(categoriaWebTxt: string) {
    console.log('CategoriaDetallePage >> openCategoria >> ' + categoriaWebTxt);

    const navExtras: NavigationExtras = {
      queryParams: {
        q: categoriaWebTxt,
        utm_campaign: this._utmCampaign,
        utm_content: this._utmContent,
        utm_medium: this._utmMedium,
        utm_source: this._utmSource,
        utm_term: this._utmTerm
      }
    };

    this._router.navigateByUrl('/blank', {skipLocationChange: true}).then(() => {
      this._router.navigate(['/categoriaDetalle'], navExtras);
    });
  }

  public btnAddFavorito(item: IProductoWeb) {
    item.Favorito = !item.Favorito;

    // registra favorito
    this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardarFavorito('Favoritos', null, null,
        this._categoriaWebTxt, item.IdProductoWeb, null, null,
        this._busquedaTxt, 'FAV => ' + item.Favorito.toString(),
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm, item.Favorito).subscribe();
    });

    let msg: string;
    if (item.Favorito) {
      msg = 'Se agregó el producto a sus favoritos.';
    } else {
      msg = 'Se quitó el producto de sus favoritos.';
    }

    this._toastCtrl.create({
      message: msg,
      animated: true,
      duration: 3000,
      color: 'pinkWhite',
      position: 'bottom',
      keyboardClose: true,
    }).then((toast) => {
      toast.present();
    });
  }

  public btnShowExistencias(item: IProductoWeb) {
    // abre popup para existencias
    this._popoverCtrl.create({
      component: ExistenciasPopoverComponent,
      componentProps: {
        '_idProductoWeb': item.IdProductoWeb,
        '_productoTxt': item.Nombre
      },
      cssClass: 'popoverExistencias',
      mode: 'md',
      animated: true
    }).then((popover) => {
      popover.present();
    });
  }

  public btnAddCarrito(item: IProductoWeb) {
    // abre popup para agregar a carrito
    this._popoverCtrl.create({
      component: CarritoTamanoPopoverComponent,
      componentProps: {
        '_idProductoWeb': item.IdProductoWeb,
        '_productoTxt': item.Nombre
      },
      cssClass: 'popoverCarrito',
      mode: 'md',
      animated: true
    }).then((popover) => {
      popover.present();
    });

  }

  //#endregion

  //#region Otros Metodos

  public getSubtituloTxt(): string {
    if (this._categoriaWebTxt == 'Pays') {
      return 'PAYS Y CHEESECAKES';
    } else if (this._categoriaWebTxt !== null) {
      return this._categoriaWebTxt.toUpperCase();
    } else {
      if (this._favoritos == true) {
        return 'FAVORITOS';
      } else if (this._busquedaTxt !== null) {
        return 'BÚSQUEDA: ' + this._busquedaTxt.toUpperCase();
      } else {
        return '';
      }
    }

  }

  public getSubtituloWidth(): string {
    switch (this._categoriaWebTxt) {
      case 'Pasteles':
        return 'width: 170px';
      case 'Pays':
        return 'width: 290px';
      case 'Individuales':
        return 'width: 210px';
      case 'Repostería':
        return 'width: 190px';
      case 'Temporada':
        return 'width: 200px';
      case 'Tienda':
        return 'width: 140px';
      default:
        if (this._busquedaTxt !== null) {
          return 'max: 300px';
        } else if (this._favoritos) {
          return 'max: 190px';
        }
    }
  }

  //#endregion

}
